import React from 'react'
import { AiFeature } from '../../../../../../models/AiFeature'
import { NoMeetingResult } from './View/NoMeetingResult'
import { AiResult } from '../../../../../../models/AiResult'
import { SegmentedMeetingResultEditView } from './Edit/SegmentedMeetingResultEditView'
import { StructuredSummaryMeetingResultEditView } from './Edit/StructuredSummaryMeetingResultEditView'

export interface MeetingResultEditViewProps {
  aiFeature: AiFeature
  aiResult: AiResult
  onResultTextContentChange: (basePath: string, path: string, resultTextContent: string | boolean) => void
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
}

export const DefaultMeetingResultEditView: React.FC<MeetingResultEditViewProps> = ({
  aiFeature,
  aiResult,
  onResultTextContentChange,
  onFormattedResultChange,
}) => {
  const { result } = aiResult

  if (!result) {
    return <NoMeetingResult />
  }

  const { type } = result

  if (type === 'segmented') {
    return (
      <SegmentedMeetingResultEditView
        aiResult={aiResult}
        aiFeature={aiFeature}
        onResultTextContentChange={onResultTextContentChange}
        onFormattedResultChange={onFormattedResultChange}
      />
    )
  }

  if (type !== 'structuredSummary') {
    return null
  }

  return (
    <StructuredSummaryMeetingResultEditView
      aiResult={aiResult}
      aiFeature={aiFeature}
      onResultTextContentChange={onResultTextContentChange}
      onFormattedResultChange={onFormattedResultChange}
    />
  )
}
